var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isLoading)?_c('div',{staticClass:"relative py-10"},[_c('div',{staticClass:"flex justify-center"},[_c('app-loading-indicator',{staticClass:"w-7 h-7"})],1)]):_c('global-latest-posts-card',{attrs:{"bots":_vm.bots}})
}
var staticRenderFns = []

export { render, staticRenderFns }